import React from 'react';
import PropTypes from 'prop-types';

import { translate } from 'react-i18next';

import Checkbox from '../../Input/Checkbox';

export class Telemetry extends React.Component {
    static displayName = 'Module.UserSettings.Telemetry';
    static propTypes = {
        t: PropTypes.func
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { t } = this.props;
        const description = 
            t('gdpr:settings.permission_for_rd_purposes', {
                '0': `<a href="https://www.polar.com/en/legal/privacy-notice#toc10" target="_blank">${t('gdpr:settings.permission_for_rd_purposes_link')}</a>`
            }) + ' ' + t('gdpr:settings.permission_for_rd_purposes_sync');

        return (
            <div className="row">
                <div className="control-group col-md-12 ">
                    <div className="col-md-3 label-wrapper">
                        <div className="left-label">
                            {t('gdpr:settings.permission_for_rd_purposes_header')}
                        </div>
                    </div>
                    <div className="controls col-md-7">
                        <Checkbox onChange={(event) => this.props.onChange(event.state.checked)}
                            checked={this.props.value}
                            key={Math.random()}
                            id="telemetry_checkbox"/>
                        <span className="info_text" dangerouslySetInnerHTML={{ __html: description }} />
                        <p className="help-block" />
                    </div>
                </div>
            </div>
        );
    }
}

Telemetry.propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func
};

export default translate('gdpr', { wait: true })(Telemetry);


// WEBPACK FOOTER //
// ./src/UserSettings/components/PrivacyView/Telemetry/index.jsx